import React from 'react';
import './index.scss';

export const Awa728x90Content = ({ src }) => {
    return (
        <div className='runup-awa-728x90'>
            <div className='runup-awa-728x90__content'>
                <div className='runup-awa-728x90__text'>Advertisement</div>
                <div className='runup-awa-728x90__widget'>
                    <iframe title='in-ad' src={src} width={728} height={90} />
                </div>
            </div>
        </div>
    );
};
